export const ProgressBar = ({ merchant, width = "full" }) => {
  // Todo cusom colors
  console.log(width);
  return (
    <div className="w-full h-1 bg-zinc-200">
      <div
        style={{
          backgroundColor: merchant?.colourSet?.primary || "#F95816",
        }}
        className={`h-full w-[${width}]`}
      />
    </div>
  );
};
